<template>
  <video
    muted
    autoplay
    ref="video"
    :src="getUrl(media)"
    @ended="ended"
    @error="error"
    @canplay="successLoad"
  />
</template>

<script>
import AdMediaController from '@/components/playlist/ad-media-playlist/ad-media-controller'

import { mapState } from 'vuex'
import Helper from '@/utils/helper'
import AdItem from '@/app/service/api/model/ad/ad-item-type/ad-item'

export default {
  name: 'AdVideo',
  mixins: [AdMediaController],
  props: {
    media: {
      type: AdItem,
      required: true
    }
  },
  data () {
    return {
      videoEl: null,
      videoTimeout: null
    }
  },
  watch: {
    media () {
      this.playVideo()
    }
  },
  computed: {
    ...mapState({
      totalVolume: state => state.playlist.volumeSetting.getVolumeLevelTotal(),
      mediaVolume: state => state.playlist.volumeSetting.getVolumeLevelMedia()
    })
  },
  methods: {
    getCurrentAudioVolume (media) {
      const volume = !Helper.isNull(media.getVolume()) ? media.getVolume() : this.totalVolume
      return Helper.isDefined(media.getVolume()) ? (volume * media.getVolume()) : volume
    },
    playVideo () {
      this.videoEl = this.$refs.video
      this.videoEl.volume = this.getCurrentAudioVolume(this.media)
      this.videoEl.muted = false
      this.videoEl.play()
          .catch(() => {})
    }
  },
  mounted () {
    this.playVideo()
  },
  beforeDestroy () {
    clearTimeout(this.videoTimeout)
  }
}
</script>
